module.exports = __webpack_public_path__ + "img/03_04ランキング１位.55a0338f.png";